var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStroke1 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#C76306",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.919 18.178c8.302 0 12.842-6.608 12.842-12.338 0-.188-.004-.375-.013-.561.882-.612 1.648-1.376 2.252-2.245-.809.345-1.68.577-2.592.682.932-.536 1.647-1.386 1.985-2.398-.873.496-1.838.858-2.866 1.052C18.703 1.527 17.53 1 16.232 1c-2.493 0-4.514 1.942-4.514 4.336 0 .34.04.671.117.989-3.751-.181-7.078-1.907-9.304-4.53-.388.64-.611 1.385-.611 2.179 0 1.504.797 2.832 2.009 3.61-.74-.022-1.436-.218-2.045-.543v.055c0 2.1 1.555 3.854 3.62 4.252-.379.099-.778.152-1.19.152-.29 0-.573-.027-.848-.078.575 1.723 2.24 2.977 4.217 3.012-1.545 1.163-3.492 1.856-5.606 1.856-.364 0-.724-.02-1.077-.06 1.998 1.23 4.37 1.948 6.919 1.948"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStroke1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stroke-1.27f5ecc1.svg";
export { ForwardRef as ReactComponent };